/**
 * Protected Route Component
 *
 * Wraps routes that require authentication
 */
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true';

export function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (BYPASS_AUTH) {
    return <Outlet />;
  }

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
